"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    actions: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        callback: PropTypes.func.isRequired,
        requiresConfirmation: PropTypes.bool,
        confirmationText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    })),
    popupStyle: PropTypes.object,
    direction: PropTypes.arrayOf(PropTypes.oneOf(['down', 'right', 'left', 'rightHang', 'leftHang', 'overlay'])),
    showOnHover: PropTypes.bool,
    testId: PropTypes.string,
    selectorRef: PropTypes.any,
    buttonStyle: PropTypes.object
};
var PopUpAction = /** @class */ (function (_super) {
    __extends(PopUpAction, _super);
    function PopUpAction(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonTrigger = React.createRef();
        _this.state = {
            hoverPopupOpen: false,
            clickPopupOpen: false,
            isConfirmOpen: false,
            selectedAction: {},
            centerX: 0,
            centerY: 0,
        };
        _this.centerFn = _this.centerContent.bind(_this);
        _this.handleBodyClickFn = _this.handleBodyClick.bind(_this);
        return _this;
    }
    PopUpAction.prototype.componentDidUpdate = function () {
        var _a = this.state, clickPopupOpen = _a.clickPopupOpen, hoverPopupOpen = _a.hoverPopupOpen;
        if (clickPopupOpen || hoverPopupOpen) {
            document.body.addEventListener('click', this.handleBodyClickFn, true);
            window.addEventListener('scroll', this.centerFn, true);
        }
        else {
            document.body.removeEventListener('click', this.handleBodyClickFn, true);
            window.removeEventListener('scroll', this.centerFn, true);
        }
    };
    PopUpAction.prototype.handleBodyClick = function (e) {
        this.centerFn();
        var isTargetingPopup = e.target.closest('.Popup') != null;
        if (!isTargetingPopup) {
            this.setState({
                hoverPopupOpen: false,
                isConfirmOpen: false,
                clickPopupOpen: false,
            });
        }
    };
    PopUpAction.prototype.handleActionClick = function (action) {
        var state = this.state;
        if (action.requiresConfirmation) {
            this.setState(__assign(__assign({}, state), { isConfirmOpen: true, selectedAction: action }));
        }
        else {
            action.callback();
        }
    };
    PopUpAction.prototype.centerContent = function () {
        if (this.buttonTrigger && this.buttonTrigger.current) {
            var _a = this.buttonTrigger.current.getBoundingClientRect(), left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
            var centerX = left + width / 2;
            var centerY = top_1 + height / 2;
            this.setState({
                centerX: centerX,
                centerY: centerY,
            });
        }
    };
    PopUpAction.prototype.togglePopup = function (e) {
        e.stopPropagation();
        var clickPopupOpen = this.state.clickPopupOpen;
        this.setState({
            hoverPopupOpen: false,
            clickPopupOpen: !clickPopupOpen,
        });
        this.centerFn();
    };
    PopUpAction.prototype.render = function () {
        var _this = this;
        var _a = this.props, actions = _a.actions, direction = _a.direction, popupStyle = _a.popupStyle, text = _a.text, showOnHover = _a.showOnHover, testId = _a.testId, buttonStyle = _a.buttonStyle;
        var state = this.state;
        var isConfirmOpen = state.isConfirmOpen, hoverPopupOpen = state.hoverPopupOpen, selectedAction = state.selectedAction, clickPopupOpen = state.clickPopupOpen;
        var callback = selectedAction.callback, confirmationText = selectedAction.confirmationText, requiresConfirmation = selectedAction.requiresConfirmation;
        var dirString = direction.reduce(function (acc, cur) {
            return acc + " Popup-container--" + cur;
        }, '');
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { "data-testid": testId, className: "Popup " + (showOnHover && 'Popup--hover'), onMouseEnter: function () {
                    _this.centerFn();
                    if (showOnHover)
                        _this.setState({ hoverPopupOpen: true });
                }, onMouseLeave: function () { return showOnHover ? _this.setState({ hoverPopupOpen: false }) : null; } },
                React.createElement("button", { ref: this.buttonTrigger, type: "button", className: "Button Button--small", onClick: this.togglePopup.bind(this), style: buttonStyle }, text),
                (hoverPopupOpen || clickPopupOpen) &&
                    React.createElement("div", { className: "Popup-container " + dirString + " is-open", style: __assign(__assign({}, popupStyle), { left: state.centerX + "px", top: state.centerY + "px" }) },
                        React.createElement("div", { className: "Popup-content" },
                            React.createElement("div", { className: "u-textLeft" }, actions.map(function (action, i) {
                                return (React.createElement("div", { key: i },
                                    React.createElement("button", { type: "button", tabIndex: 0, className: "u-padEndsSm u-padSidesMd", style: {
                                            cursor: 'pointer',
                                            appearance: 'none',
                                            border: 'none',
                                            background: 'none',
                                            width: '100%',
                                            textAlign: 'left',
                                        }, onClick: _this.handleActionClick.bind(_this, action) }, action.text),
                                    React.createElement("hr", { className: "Divider u-spaceEndsNone" })));
                            }))))),
            React.createElement("div", { className: "Popup" },
                React.createElement("div", { className: "Popup-container Popup-container--overlay " + (requiresConfirmation && isConfirmOpen ? 'is-open' : ''), style: {
                        left: state.centerX + "px",
                        top: state.centerY + "px",
                    } },
                    React.createElement("div", { className: "Popup-content u-padMd" },
                        React.createElement("h3", { className: "u-spaceBottomSm u-textCenter" }, "Are you sure?"),
                        React.createElement("p", { className: "u-textLeft" }, confirmationText),
                        React.createElement("div", { className: "u-textCenter u-spaceTopMd" },
                            React.createElement("button", { type: "button", onClick: function () {
                                    return _this.setState(__assign(__assign({}, state), { isConfirmOpen: false, selectedAction: {} }));
                                }, className: "u-spaceRightSm Button Button--negative" }, "Cancel"),
                            React.createElement("button", { type: "button", onClick: function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    callback(args);
                                    _this.setState(__assign(__assign({}, state), { isConfirmOpen: false, selectedAction: {} }));
                                }, className: "Button Button--primary" }, "Confirm")))))));
    };
    // eslint-disable-next-line react/static-property-placement
    PopUpAction.defaultProps = {
        showOnHover: true,
    };
    return PopUpAction;
}(React.Component));
exports.default = PopUpAction;
